import { render, staticRenderFns } from "./Verdok.vue?vue&type=template&id=5d1dc996&"
import script from "./Verdok.vue?vue&type=script&lang=js&"
export * from "./Verdok.vue?vue&type=script&lang=js&"
import style0 from "./Verdok.vue?vue&type=style&index=0&id=5d1dc996&prod&lang=css&"
import style1 from "../Wizard.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports